module.exports = __webpack_public_path__ + "img/google-text.83fcc702.svg";